<div class="app-airdrop" [ngClass]="httpService.theme">
    <div class="top-section">
        <div class="">
            <cf-card type="empty" [theme]="httpService.theme">
                <div class="section-heading">
                    Rewards vs Date
                </div>
                <div class="bottom-section" [ngClass]="{'loader-container': loading_charts}">
                    <cf-loader *ngIf="loading_charts" class="loader"></cf-loader>
                    <div class="chart-controls">
                        <div class="chart-duration-controls">
                            <div class="chart-control" matTooltip="12 hrs"
                                [ngClass]="{'active-control': current_chart_duration === '12h'}"
                                (click)="changeMoonCreditChartDuration('12h')">12H</div>
                            <div class="chart-control" matTooltip="1 day"
                                [ngClass]="{'active-control': current_chart_duration === '1d'}"
                                (click)="changeMoonCreditChartDuration('1d')">1D</div>
                            <div class="chart-control" matTooltip="3 day"
                                [ngClass]="{'active-control': current_chart_duration === '3d'}"
                                (click)="changeMoonCreditChartDuration('3d')">3D</div>
                            <div class="chart-control" matTooltip="1 week"
                                [ngClass]="{'active-control': current_chart_duration === '1w'}"
                                (click)="changeMoonCreditChartDuration('1w')">1W</div>
                        </div>
                        <div class="chart-type-controls">
                            <div class="chart-control" matTooltip="cumulative"
                                [ngClass]="{'active-control': current_chart_type === 'cumulative'}"
                                (click)="changeMoonCreditChartType('cumulative')">Cu</div>
                            <div class="chart-control" matTooltip="Non cumulative"
                                [ngClass]="{'active-control': current_chart_type === 'non_cumulative'}"
                                (click)="changeMoonCreditChartType('non_cumulative')">NC</div>
                        </div>
                    </div>


                    <div *ngIf="!loading_charts">
                        <app-line-chart [lineConfig]="chartLineConfig" title="" [height]="350"
                            [showLegend]="false"></app-line-chart>
                    </div>
                </div>
            </cf-card>
        </div>

        <div class="d-grid gap-4">
            <cf-card type="empty" [theme]="httpService.theme">
                <div class="right d-flex flex-column gap-3">
                    <div class="" style="font-size: 1.1rem;">
                        Collect Moons for $CRED airdrops
                    </div>
                    <div class="moons-card-container">
                        <div class="card-field">
                            <div class="card-value">{{ total_user_moon | number : '0.0-0' }} <img
                                    src="https://assets.credible.finance/IMG312.png" alt="" /></div>
                            <div class="card-heading">Moons Earned</div>
                        </div>

                        <div class="card-field">
                            <div class="card-value">{{ rank }}<sup>{{rank_suffix}}</sup></div>

                            <div class="card-heading">Current Rank<i class="fa-solid fa-info-circle"
                                    matTooltip="Your rank in top moon holder leaderboard"></i></div>
                        </div>

                        <div class="card-field">
                            <div class="card-value">{{ completed_task_count }}/{{ total_task_count }}</div>
                            <div class="card-heading">Tasks Completed</div>
                        </div>

                        <div class="card-field">
                            <div class="card-value">{{ stats.last_7d | number : '0.0-0' }} <img
                                    src="https://assets.credible.finance/IMG312.png" alt="" /></div>

                            <div class="card-heading">Last 7 days</div>
                        </div>

                        <div class="card-field">
                            <div class="card-value">{{ stats.last_30d | number : '0.0-0' }} <img
                                    src="https://assets.credible.finance/IMG312.png" alt="" /></div>

                            <div class="card-heading">Last 30 days</div>
                        </div>

                        <div class="card-field">
                            <div class="card-value">{{ stats.last_60d | number : '0.0-0' }} <img
                                    src="https://assets.credible.finance/IMG312.png" alt="" /></div>

                            <div class="card-heading">Last 60 days</div>
                        </div>
                    </div>

                    <div class="w-100">
                        <cf-button theme="dark" label="Learn about Airdrop"
                            (clicked)="redirectUrl('https://crediblefinance.notion.site/airdrop')" type="outline">
                        </cf-button>
                    </div>
                </div>
            </cf-card>
        </div>
    </div>

    <div id="joinSocialMedia-google-recaptcha"></div>

    <div class="tasks">
        <div class="tasks-heading" *ngIf="pending_tasks.length > 0">Tasks to get Moons</div>

        <div class="grid w-100 mt-2" *ngIf="pending_tasks.length > 0">
            <cf-card [theme]="httpService.theme" type="empty" [fullHeight]="true" *ngFor="let task of pending_tasks"
                style="border-top: 2px solid #ffa500; border-top-left-radius: 5px; border-top-right-radius: 5px;">
                <app-airdrop-join-card-waitlist [task]="task" *ngIf="task.id === 'join_card_waitlist'">
                </app-airdrop-join-card-waitlist>
                <app-airdrop-buy-node [task]="task" *ngIf="task.id === 'buy_node'"></app-airdrop-buy-node>
                <app-airdrop-connect-wallet [task]="task"
                    *ngIf="task.id === 'connect_wallet'"></app-airdrop-connect-wallet>
                <app-airdrop-credit-score [task]="task" *ngIf="task.id === 'credit_score'"></app-airdrop-credit-score>
                <app-airdrop-discord [task]="task" *ngIf="task.id === 'discord'"></app-airdrop-discord>
                <app-airdrop-telegram [task]="task" *ngIf="task.id === 'telegram'"></app-airdrop-telegram>
                <app-airdrop-twitter [task]="task" *ngIf="task.id === 'twitter'"></app-airdrop-twitter>
                <app-airdrop-kyc [task]="task" *ngIf="task.id === 'kyc'"></app-airdrop-kyc>
                <app-airdrop-lend [task]="task" *ngIf="task.id === 'lend_pusd'"></app-airdrop-lend>
                <app-airdrop-share-on-twitter [task]="task"
                    *ngIf="task.id === 'share_on_twitter'"></app-airdrop-share-on-twitter>
                <app-airdrop-referral [task]="task" *ngIf="task.id === 'referral'"
                    [referred_user_count]="referred_user_count"></app-airdrop-referral>
            </cf-card>
        </div>

        <div class="tasks-heading" *ngIf="completed_tasks.length > 0">Completed tasks</div>

        <div class="grid w-100" *ngIf="completed_tasks.length > 0">
            <cf-card [theme]="httpService.theme" type="empty" [fullHeight]="true" *ngFor="let task of completed_tasks"
                style="border-top: 2px solid #229173; border-top-left-radius: 5px; border-top-right-radius: 5px;">
                <app-airdrop-join-card-waitlist [task]="task" *ngIf="task.id === 'join_card_waitlist'">
                </app-airdrop-join-card-waitlist>
                <app-airdrop-buy-node [task]="task" *ngIf="task.id === 'buy_node'"></app-airdrop-buy-node>
                <app-airdrop-connect-wallet [task]="task"
                    *ngIf="task.id === 'connect_wallet'"></app-airdrop-connect-wallet>
                <app-airdrop-credit-score [task]="task" *ngIf="task.id === 'credit_score'"></app-airdrop-credit-score>
                <app-airdrop-discord [task]="task" *ngIf="task.id === 'discord'"></app-airdrop-discord>
                <app-airdrop-telegram [task]="task" *ngIf="task.id === 'telegram'"></app-airdrop-telegram>
                <app-airdrop-twitter [task]="task" *ngIf="task.id === 'twitter'"></app-airdrop-twitter>
                <app-airdrop-kyc [task]="task" *ngIf="task.id === 'kyc'"></app-airdrop-kyc>
                <app-airdrop-lend [task]="task" *ngIf="task.id === 'lend_pusd'"></app-airdrop-lend>
                <app-airdrop-share-on-twitter [task]="task"
                    *ngIf="task.id === 'share_on_twitter'"></app-airdrop-share-on-twitter>
                <app-airdrop-referral [task]="task" *ngIf="task.id === 'referral'"
                    [referred_user_count]="referred_user_count"></app-airdrop-referral>
            </cf-card>
        </div>
    </div>
    <div class="w-100 third pt-5">
        <div class="text-center mb-5">
            <div class="faq-heading">Frequently Asked Questions</div>
            <div class="desc_color text-center font">
                Do you have any questions? Here are some frequently asked
                questions that we have answered
            </div>
        </div>
        <div class="faq_questions pt-3" *ngIf="questions.length > 0">
            <div class="box" *ngFor="let item of questions; index as i">
                <div *ngIf="!item.open" class="one mb-2 d-flex justify-content-between" (click)="openQues(i)">
                    <span class="questions bold">
                        {{ item.q }}
                    </span>
                    <span>
                        <i class="fa-solid fa-plus" *ngIf="!item.open" (click)="openQues(i)"></i>
                    </span>
                </div>
                <div *ngIf="item.open" class="one mb-2 d-flex justify-content-between" (click)="closeQues(i)">
                    <span class="questions bold">
                        {{ item.q }}
                    </span>
                    <span>
                        <i class="fa-solid fa-minus" *ngIf="item.open" (click)="closeQues(i)"></i>
                    </span>
                </div>
                <div *ngIf="item.open" class="two">
                    <ul *ngIf="item.hasBullets">
                        <li class="answers font_lg desc_color" *ngFor="let answer of item.a">
                            {{ answer }}
                        </li>
                    </ul>
                    <p *ngIf="!item.hasBullets" class="font_lg desc_color answers">
                        {{ item.a }}
                    </p>
                </div>
                <!-- </div> -->
            </div>
        </div>
    </div>
</div>